import { Component, OnInit,Input,SimpleChanges, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {LoginComponent} from '../login/login.component';
import * as FileSaver from 'file-saver';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { ToastrService } from 'ngx-toastr';
import {ChangePasswordComponent} from '../submitdata/user-management/change-password/change-password.component';
import {  CookieService  } from 'ngx-cookie-service'; 
import { EncdecService } from 'src/app/services/encdec.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { isNullOrUndefined } from 'util';
import { TranslateService } from '@ngx-translate/core';
import { ProfileFormComponent } from '../login/profile-form/profile-form.component';
import { MapconstantsModule } from '../geoportal/gis/mapconstants/mapconstants.module';
import { HttpClient } from '@angular/common/http';
import { Output, EventEmitter } from '@angular/core';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() selectedLang =new EventEmitter<string>();
  activespineer : boolean;
  dontshowbtnsfornf : boolean = true;
  disablebell : boolean = false;
  modalRef;
  @ViewChild('videoModal',{})videoModal;
  myObserver;
  selectedLanguage  :any;
  notificationcount = 0;
  showlessnotifications : boolean = true;
  shownotifications = false;
  notifications = [];
  showbellicon : boolean = false;
  isUserLogin : Boolean;
  userdetail:object = {};
  state_nodal_officer;
  allnotifications : [];
  isActive={
    gis :false,
    mis:false,
    submitdata:false,
    video:false
  }
  userOptions: string[] = ["header.Change Password", "header.Logout"];
  selectedOption: string = "";
  userdetails: any;
  dist_nodal_officer: string;
  notificationbell: any;
  locationName: any;
  userDropdownOptions:string[] = ["Change Password", "Logout"];
  specificLang: string = 'en';
  loginDetail: any;
  downloadflag: any;
  logedIn: boolean = false;
  ipAddress: any;
  newicon: boolean;
  broadcastData: any;
  showNewIcon: boolean;
  constructor(
    private router : Router,
    private translate: TranslateService,
    private modalService: NgbModal,
    private constants : ConstantsModule,
    private sessionlogin : AuthloginService,
    public utils : UtilsModule,
    private toastr : ToastrService,
    private cookie : CookieService,
    private mapconstats : MapconstantsModule,
    private encdecservice : EncdecService,
    private submitdataservice : SubmitdataService,
    private http : HttpClient,
  ) {
    translate.setDefaultLang('en');
    this.myObserver = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.initializeOnStateLoad();
      }
    });
  }

  ngOnInit() {
    this.userdetails = this.sessionlogin.checkloginstatus();   
    if(this.userdetails!=null && this.userdetails!=undefined){
      this.logedIn = true;
      this.getBroadcastDocs();
    } else{
      this.logedIn = false;
    }
    this.downloadflag = this.submitdataservice.LANGUAGE_LIST;
    if(this.mapconstats.specificLang != null )
    this.specificLang = this.mapconstats.specificLang;
    let s = String(location);
    s.includes('gis')?this.isActive.gis =true:s.includes('mis')?this.isActive.mis = true:s.includes('submitdata')?this.isActive.submitdata=true:'';
    if(this.sessionlogin.checkloginstatus()){
      this.userdetail = this.sessionlogin.checkloginstatus();
       this.userdetail['login'] = this.encdecservice.rsadec(this.constants.PRIVATE_KEY,this.userdetail['login']); 
      if(this.userdetail['roles'][0] != 'MISCELLANEOUS_USER'){
        this.loginDetail = this.userdetail['loggedUserData']['userProfile']['locationName'];
      } else {
        this.loginDetail = this.userdetail['loggedUserData']['userProfile']['fname'];
      }
    }
    this.sessionlogin.getIPAddress();
    this.submitdataservice.getassesmentYear();
    // this.getBroadcastDocs();
    this.useLanguage('en');
    
  }
  // getIPAddress()
  // {
  //   this.http.get("http://api.ipify.org/?format=json").subscribe((res:any)=>{
  //     this.ipAddress = res.ip;
  //   });
  // }
  ProfileForm(){
    this.modalRef = this.modalService.open(ProfileFormComponent,{backdrop: 'static',windowClass: 'backgroundTransparent my-class'});

  }
  useLanguage(language: string) {
    this.specificLang = language;
    this.mapconstats.specificLang = language;
    this.translate.use(language);
    this.selectedLang.emit(language);
  }
  initializeOnStateLoad(): void {
    this.showbellicon = false
    let s = String(location);
    this.isUserLogin = this.sessionlogin.checkloginstatus()?true:false;   
    this.state_nodal_officer = this.constants.USER_TYPES["STATE_NODAL_OFFICER"];
    this.dist_nodal_officer  = this.constants.USER_TYPES['DISTRICT_NODAL_OFFICER']
    if(this.sessionlogin.checkloginstatus()){
      this.userdetail = this.sessionlogin.checkloginstatus();
      // this.loginDetail = this.userdetail['loggedUserData']['userProfile']['locationName']
      this.userdetail['login'] = this.encdecservice.rsadec(this.constants.PRIVATE_KEY,this.userdetail['login']); 
      if(this.userdetail['roles'][0] == this.state_nodal_officer || this.userdetail['roles'][0] == this.dist_nodal_officer){
        this.showbellicon = true;
        this.getnotifications();
      }
    }
  }
  getnotifications(){
    this.activespineer = true;
    this.allnotifications = [];

    let postdata = {
      "lu" : this.userdetail['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
      "component" : 1,
      "userType" : this.state_nodal_officer == this.userdetail['roles'][0] ? this.constants.USER_TYPES["VALIDATION_AGENCY"] : this.constants.USER_TYPES["STATE_NODAL_OFFICER"],
      "actionTypeList" : ["REJECt", "MODIFY"]
    }
    this.submitdataservice.getnotifications(postdata).subscribe(data =>{
      if(!isNullOrUndefined(data)){
      this.notificationcount = Object.keys(data).length
    }
      if(data.length > 0){
        this.disablebell = false
        this.allnotifications = data;
        if(this.allnotifications.length > 10){
          this.dontshowbtnsfornf = false;
          this.notifications = this.allnotifications.slice(0,10);
        } else {
          this.dontshowbtnsfornf = true;
          this.notifications = this.allnotifications;
        }
      } else {
        this.disablebell = true;
      }
      this.activespineer = false;
    });
  }

  getBroadcastDocs() {
    // this.broadcastData = null;
    let rawdata;
    let postdata = {
      "pu": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "lu": "f78f615d-e270-4f93-90ac-27608e756b85",
      // "ay": this.selectedYearMonth['ay'],
      // "subTp": this.selectedYearMonth['month'],
      "mode": "COUNT",
      "limit": 10
    }
    this.submitdataservice.getBroadcastDetails(postdata).subscribe(data => {
      rawdata = data.data;
      this.enableNewIcon(rawdata)
    })
  }

  enableNewIcon(rdata) {
    this.broadcastData = rdata;
    let todaydate = new Date();
    let lastDate = new Date();
    var day = lastDate.getDate() - 10;
    lastDate.setDate(day);
    // lastDate.setTime(day);
    // if(this.broadcastData[0].insertTs){
    // }
    // for (let i = 0; i <= this.broadcastData.length; i++) {      
    //   let doctime = new Date(this.broadcastData[i].insertTs)
    //   if ((doctime <= todaydate) && (doctime >= lastDate)) {
    //     // return true;
    //     this.showNewIcon = true;
    //   }
    // }
    if(this.broadcastData){
      this.broadcastData.forEach(doc =>{
        let doctime = new Date(doc.insertTs)
        if ((doctime <= todaydate) && (doctime >= lastDate)) {
          this.showNewIcon = true;
        }
      })

    }
  }
  
  viewallnotifications(){
    this.showlessnotifications = false;
    this.notifications = this.allnotifications;
  }
  viewlessnotifications(){
    this.showlessnotifications = true;
    this.notifications = this.allnotifications.slice(0,10)
  }
  enablenotifications(){
    this.shownotifications = this.shownotifications ? false : true;
    if(this.shownotifications)
      this.viewlessnotifications();
  }
  closenotifications(){
    this.shownotifications = false;
  }
  ChangeOptions(newOption: string) { 
    this.selectedOption = newOption;
    if(this.selectedOption == "Change Password"){
       this.changePassword();
    }else{
      this.logoutUser();
    }

  }
  openVideoPopup(){
    this.modalRef = this.modalService.open(this.videoModal,{windowClass:'modal-dialog-centered', centered:true});
  }
  CloseVideoModal(){
    this.modalRef.dismiss();
  }
  changePassword(){
    const modal = this.modalService.open(ChangePasswordComponent, { size: 'lg' });
    }
  redirectmis(){
    
    this.router.navigate(["/mis",{}])
  }
  redirectGis(){
    this.router.navigate(["/gis"]);
  }
  getLanguageFile(data){
    if(data == "english"){
      window.open("./assets/report/DGCENGLISH.html");
      // this.submitdataservice.getlanguageData().subscribe(response =>{
      //   if(response){
      //     let filename: string = "english.docx";
      //     var newBlob = new Blob([response], { type: 'text/json; charset=utf-8' });
      //     const data = window.URL.createObjectURL(newBlob);
      //     var link = document.createElement('a');
      //     link.href = data;
      //     link.download = filename;
      //     link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      //     setTimeout(function () {
      //         window.URL.revokeObjectURL(data);
      //         link.remove();
      //     }, 100);
      //   }
      // })
    } else if(data == "hindi"){
      window.open("./assets/report/DGCHINDI.html")
      // this.submitdataservice.getlanguagehindiFile().subscribe(response =>{
      //   if(response){
      //     let filename: string = "hindi.docx";
      //     var newBlob = new Blob([response], { type: 'text/json; charset=utf-8' });
      //     const data = window.URL.createObjectURL(newBlob);
      //     var link = document.createElement('a');
      //     link.href = data;
      //     link.download = filename;
      //     link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      //     setTimeout(function () {
      //         window.URL.revokeObjectURL(data);
      //         link.remove();
      //     }, 100);
      //   }
      // })
    }
  }
  public openloginpopup(){
    var  urlParams;
    this.modalRef = this.modalService.open(LoginComponent,{backdrop: 'static',windowClass: 'backgroundTransparent my-class'});
    this.modalRef.componentInstance.modelLoaderActive = true;
    this.modalRef.componentInstance.urlParams = urlParams;
  }
  
  redirectToSubmitData(){
    let userdetails = this.sessionlogin.checkloginstatus()
    if(userdetails){
      this.activespineer = true;
      let urlParams = {'component':this.constants.ROLEBASEDDEFAULTCOMP[userdetails['roles'][0]]}
      this.router.navigate(["/submitdata",urlParams]);
    }
    // else{
    //   this.modalRef = this.modalService.open(LoginComponent,{backdrop: 'static',windowClass: 'backgroundTransparent my-class'});
    //   this.modalRef.componentInstance.modelLoaderActive = true;
    //   this.modalRef.componentInstance.fromdatasubmit = true;
    // }
    
  }
  redirectWhatsNew(){
    this.router.navigate(["/whatsNew",{}])
  }
  getDropdownOptions(option){
    this.selectedOption = option;
    if(this.selectedOption == "Change Password"){
      this.changePassword();
    } else{
      this.logoutUser();
    }
  }
  pdfDownload(){
    this.activespineer = true;
   let pdfName = "AuthorityNotification.pdf";
   let pdfUrl = './assets/report/47_AuthorityNotification.pdf'
   FileSaver.saveAs(pdfUrl,pdfName);
   this.activespineer = false;
  }
  public logoutUser(){
    let url  = this.router.url; 
    this.activespineer = true;    
    this.sessionlogin.logoutuser().subscribe(logoutres =>{
       if(logoutres['result']['success']){
        this.sessionlogin.clearsession();
        if(url.search('submitdata') != -1){
          this.router.navigate(["/gis"]);
          this.toastr.success("Logged out successfully");
        }else if(url.search('whatsNew') != -1){
          this.router.navigate(["/gis"]);
          this.toastr.success("Logged out successfully");
        }else{
          setTimeout(() => { location.reload(); }, 10);
        }
      } else {
        this.toastr.error(logoutres['result']['message'])
      }
     
    })
    
  }

}
